<template>
  <div>
    <v-icon
      class="uikit-icon list show-btn"
      :class="isXs ? 'mr-2' : 'mr-4'"
      title="Посмотреть отчет"
      @click="$emit('goToFilledFormValue')"
    />
    <v-icon
      v-if="isAdmin"
      class="uikit-icon settings show-btn"
      :class="isXs ? 'mr-1' : 'mr-4'"
      title="Редактировать"
      @click="$emit('edit')"
    />
    <v-menu bottom left :offset-y="true">
      <template #activator="{ on }">
        <v-icon class="uikit-icon more-vertical edit-btn" v-on="on" />
      </template>

      <v-list class="pt-3 pl-2 pr-2 pb-3" min-width="200" max-width="300">
        <ListItemButton title="Зарегистрировать на месте" icon="pen" @click="$emit('goToFilledForm')" />
        <ListItemButton v-if="isAdmin" title="Создать рассылку" icon="mail" @click="$emit('goToMailForEventForm')" />
        <ListItemButton title="Выгрузить форму" icon="download" @click="$emit('downloadXlsxTemplate')" />
        <ListItemButton title="Заполнить форму" icon="upload" @click="$emit('openFormTemplateExcelDialog')" />
        <ListItemButton title="Скачать отчет" icon="file-text" @click="$emit('openReportTemplatesListForDownloadDialog')" />
        <ListItemButton title="Добавить шаблон отчета" icon="file-table-box-multiple-outline" @click="$emit('goToReportTemplatesForEventForm')" />
        <ListItemButton title="Скачать бейджи" icon="download" @click="$emit('downloadEventBadge')" />
        <ListItemButton v-if="isAdmin" title="Бейджи" icon="upload" @click="$emit('openBadgesPage')" />
        <ListItemButton v-if="isAdmin" title="Удалить" icon="trash" @click="$emit('remove')" />
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import ListItemButton from '@/featureSlicedDesign/entites/ListItemButton'
import { mapGetters } from 'vuex'

export default {
  name: 'ActionsBtnForForm',

  components: { ListItemButton },

  computed: {
    ...mapGetters('breakpoint', ['isXs']),
    ...mapGetters('user', ['isAdmin']),
  },
}
</script>
